// extracted by mini-css-extract-plugin
export default {"SideNav":"HeaderSideNav_SideNav__-CTYx","header":"HeaderSideNav_header__7c1Xb","container":"HeaderSideNav_container__Mj014"};